import { z } from "zod";
import {
    AccountRolePresence,
    AccountRulePresence,
    AccountSource,
    AccountStatus,
} from "@common/types/domains/accounting/account";
import { AccountSubtype } from "@common/constants/domains/accounting/accounts";
import { form1099BoxFilterValueSchema } from "@common/schemas/domains/accounting/account.schema";
import {
    useWorkspaceUserCache,
    WORKSPACE_USER_CACHE_KEYS,
} from "@hooks/useWorkspaceUserCache";

const coaFiltersCacheSchema = z.object({
    accountStatus: z.nativeEnum(AccountStatus).optional(),
    accountSource: z.nativeEnum(AccountSource).optional(),
    accountRolePresence: z.nativeEnum(AccountRolePresence).optional(),
    accountRulePresence: z.nativeEnum(AccountRulePresence).optional(),
    accountSubtypes: z.array(z.nativeEnum(AccountSubtype)).optional(),
    form1099Boxes: z.array(form1099BoxFilterValueSchema).optional(),
    coaTemplateGroupKeys: z.array(z.string()).optional(),
});

export type CoaFiltersCache = z.infer<typeof coaFiltersCacheSchema>;

export function useCoaFiltersCache(): [
    CoaFiltersCache | undefined,
    (value: CoaFiltersCache) => void,
] {
    return useWorkspaceUserCache<CoaFiltersCache>(
        WORKSPACE_USER_CACHE_KEYS.CHART_OF_ACCOUNTS_PAGE_FILTERS_CACHE_KEY,
        coaFiltersCacheSchema,
    );
}
